import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { getCleanThreadId } from '../views/AppNavigator/Messages/helpers'
import toast from 'react-hot-toast'
import { SendMessageToThreadParams, ThreadMessage } from './types'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export const useSendMessageToThreadMutation = () => {
  const fetchWithAuth = useFetchWithAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: SendMessageToThreadParams) => {
      try {
        const { thread_id, message } = params
        const cleanThreadId = getCleanThreadId(thread_id)

        const response = await fetchWithAuth(
          `${URL}/threads/${cleanThreadId}/messages`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(message),
          }
        )

        return response as ThreadMessage
      } catch (error) {
        console.error('Error sending message:', error)
        toast.error('Failed to send message. Please try again.')
        throw error
      }
    },
    onSuccess: (data, variables) => {
      // Show success toast
      toast.success('Message sent successfully')

      // Invalidate the specific thread query
      queryClient.invalidateQueries({
        queryKey: ['thread', variables.thread_id],
      })

      // Invalidate threads list to update last message
      queryClient.invalidateQueries({
        queryKey: ['threads'],
      })
    },
  })
}
